const backInStockCountDown = (date) => ({
  targetDate: null,
  timeLeft: {
    days: 0,
    hours: 0,
    minutes: 0,
  },
  isExpired: false,
  showCountdown: true,
  interval: null,

  init() {
    if (!date) {
      console.warn("Back in stock countdown: No date provided");
      this.showCountdown = false;
      return;
    }

    this.targetDate = new Date(date);

    if (isNaN(this.targetDate.getTime())) {
      console.warn("Back in stock countdown: Invalid date format", date);
      this.showCountdown = false;
      return;
    }
    this.startCountdown();
  },

  startCountdown() {
    this.calculateTimeLeft();

    this.interval = setInterval(() => {
      this.calculateTimeLeft();
    }, 1000);
  },

  calculateTimeLeft() {
    const now = new Date().getTime();
    const target = this.targetDate.getTime();
    const difference = target - now;

    if (difference <= 0) {
      this.isExpired = true;
      this.showCountdown = false;
      this.timeLeft = {
        days: 0,
        hours: 0,
        minutes: 0,
        seconds: 0,
      };

      if (this.interval) {
        clearInterval(this.interval);
        this.interval = null;
      }

      return;
    }

    const days = Math.floor(difference / (1000 * 60 * 60 * 24));
    const hours = Math.floor((difference % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    const minutes = Math.floor((difference % (1000 * 60 * 60)) / (1000 * 60));
    const seconds = Math.floor((difference % (1000 * 60)) / 1000);

    this.timeLeft = {
      days,
      hours,
      minutes,
      seconds,
    };
  },

  formatNumber(num) {
    return num < 10 ? `0${num}` : num;
  },

  getTimeUnitText(value, unit) {
    if (value === 1) {
      return unit.slice(0, -1);
    }
    return unit;
  },

  destroy() {
    if (this.interval) {
      clearInterval(this.interval);
      this.interval = null;
    }
  },
});

export default backInStockCountDown;